import React from 'react';
import styles from './NotificationBox.module.scss';
import { ReactComponent as Error } from '../../icons/Error/Error.svg';
import { ReactComponent as Success } from '../../icons/MarkRead/MarkRead.svg';
import Icon from '../Icons/Icon/Icon';
import I18n from '../I18n/I18n/I18n';
export default function NotificationBox(_ref) {
  var _ref$fade = _ref.fade,
    fade = _ref$fade === void 0 ? false : _ref$fade,
    i18n = _ref.i18n,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'success' : _ref$type;
  var SvgIcon = type === 'success' ? Success : Error;
  return /*#__PURE__*/React.createElement("span", {
    className: "".concat(styles.notification, " ").concat(styles[type], " ").concat(fade ? styles.fade : ''),
    role: "alert"
  }, /*#__PURE__*/React.createElement(Icon, {
    className: styles.icon
  }, /*#__PURE__*/React.createElement(SvgIcon, null)), /*#__PURE__*/React.createElement(I18n, {
    i18n: i18n
  }));
}